import React from 'react'
import '../App.css'
import Navbar from '../components/navbar.js'
import Footer from '../components/footer.js'
import location from '../imagines/icons8-location-48.png'
const ContactUs = () => {
  return (
    <>
      <Navbar />
      <div className='contactUs'>
        {/* <div className='title'>
          <h1 className=''>Contact Us</h1>
        </div> */}
        <div className ='title'>
            <h1><span className="font-letter">C</span>ontact <span className="font-letter">U</span>s</h1>
        </div>
        <div className='contactUs-container'>
          <div className="marquee-wrapper">
            <h2 className="title-location-hours">
              <img src={location} alt="Location Icon" />
              Locations & hours&nbsp;&nbsp;&nbsp;
            </h2>
            <h2 className="title-location-hours">
              <img src={location} alt="Location Icon" />
              Locations & hours&nbsp;&nbsp;&nbsp;
            </h2>
          </div>
          <div className="marquee-wrapper">
            <h2 className="title-location-hours">
              <img src={location} alt="Location Icon" />
              Locations & hours&nbsp;&nbsp;&nbsp;
            </h2>
            <h2 className="title-location-hours">
              <img src={location} alt="Location Icon" />
              Locations & hours&nbsp;&nbsp;&nbsp;
            </h2>
          </div>
          <hr/>
          <h2>inails and spa 1</h2>
          <div className='contactUs-content'>
            <div className='contactUs-content-left'>
              <iframe className='map-1'
                  title='iNails and Spa 1'
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d53749.24386983058!2d-117.1552297638331!3d32.65072156010861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d95207003962b9%3A0xb19981fc9cf10586!2siNails%20and%20Spa!5e0!3m2!1sen!2sus!4v1744848577463!5m2!1sen!2sus" 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade">
              </iframe>
              <div className="contact-address-wrapper">
                <p className="contact-address">
                  <strong>Address: </strong>
                  <a href='https://maps.app.goo.gl/Ase7DwMs3NpYz1WU6' target='_blank' rel="noopener noreferrer"><u>6 N 4th Ave #3,Chula Vista, CA 91910</u></a>
                  <br/>
                  <strong>Phone: </strong>    
                  <a href='tel:+16198822199' className='call-1'><u>(619) 882-2199</u></a>
                </p>
                <p className="contact-buttons">
                  <a href='tel:+16198822199' className="get-call">Call Now</a>
                  <a href='https://maps.app.goo.gl/Ase7DwMs3NpYz1WU6' target='_blank' rel="noopener noreferrer" className="get-directions-btn">Get Direction</a>
                </p>
              </div>              
            </div>
            <div className='contactUs-content-right'>
              <h1>BUSINESS HOURS</h1>
              <ul className="business-hours">
                <li><strong>Monday:</strong> 9:00 AM – 7:00 PM</li>
                <li><strong>Tuesday:</strong> 9:00 AM – 7:00 PM</li>
                <li><strong>Wednesday:</strong> 9:00 AM – 7:00 PM</li>
                <li><strong>Thursday:</strong> 9:00 AM – 7:00 PM</li>
                <li><strong>Friday:</strong> 9:00 AM – 7:00 PM</li>
                <li><strong>Saturday:</strong> 9:00 AM – 7:00 PM</li>
                <li><strong>Sunday:</strong> 10:00 AM – 6:00 PM</li>
              </ul>
            </div>
          </div>
          <hr/>
          <h2>inails and spa 2</h2>
          <div className='contactUs-content contactUs-content-2'>
            <div className='contactUs-content-right'>
                <h1>BUSINESS HOURS</h1>
                <ul className="business-hours">
                  <li><strong>Monday:</strong> 9:00 AM – 7:00 PM</li>
                  <li><strong>Tuesday:</strong> 9:00 AM – 7:00 PM</li>
                  <li><strong>Wednesday:</strong> 9:00 AM – 7:00 PM</li>
                  <li><strong>Thursday:</strong> 9:00 AM – 7:00 PM</li>
                  <li><strong>Friday:</strong> 9:00 AM – 7:00 PM</li>
                  <li><strong>Saturday:</strong> 9:00 AM – 7:00 PM</li>
                  <li><strong>Sunday:</strong> 10:00 AM – 6:00 PM</li>
                </ul>
              </div>
            <div className='contactUs-content-left'>
              <iframe className='map-1'
                  title='iNails and Spa 2'
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d53749.251959340894!2d-117.15540147014929!3d32.65070810252068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d94e1da848fa4d%3A0xabc8af2010fb1856!2siNails%20and%20Spa%202!5e0!3m2!1sen!2sus!4v1744852501069!5m2!1sen!2sus" 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade">
              </iframe>
              <div className="contact-address-wrapper">
                <p className="contact-address">
                  <strong>Address: </strong>
                  <a href='https://maps.app.goo.gl/mWmVz51cJG9EaNQ56' target='_blank' rel="noopener noreferrer"><u>3041 Bonita Rd, Chula Vista, CA 91910</u></a>
                  <br/>
                  <strong>Phone: </strong>
                  <a href='tel:+16194222141' className='call-1'><u>(619) 422-2141</u></a>
                </p>
                <p className="contact-buttons">
                  <a href='tel:+16194222141' className="get-call">Call Now</a>
                  <a href='https://maps.app.goo.gl/mWmVz51cJG9EaNQ56' target='_blank' rel="noopener noreferrer" className="get-directions-btn">Get Direction</a>
                </p>
              </div>              
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default ContactUs